import { searchV4 } from "./search";

export type GlobalSearchEntityType = "contact" | "matter";

export type GlobalSearchResult = {
  entityType: GlobalSearchEntityType;
  entityId: string;
  title: string;
  subtitle?: string | null;
  score: number;
  matchedFields: string[];
};

export type RetrieveGlobalSearchInput = {
  query: string;
  entityType?: GlobalSearchEntityType;
  cursor?: string;
  limit?: number;
};

export const retrieveGlobalSearchV4 = (
  input: RetrieveGlobalSearchInput,
  signal?: AbortSignal,
) =>
  searchV4<GlobalSearchResult>(
    { view: "suggestions", ...input, limit: input.limit ?? 20 },
    signal,
  );
